<template>
  <div class="relative pb-48">
    <MultiPictureForm title="Ambil foto" @selected="(a) => (foto = a)" :minimum="2" />
    <!-- {{ local }} -->
    <TextBoxForm title="Keterangan" @selected="(a) => (keterangan = a)" />

    <div class="fixed max-w-xl w-full bottom-0 bg-white px-2 py-4 flex items-end shadow-md shadow-primary">
      <div class="w-full pr-2">
        <div class="mb-2">
          <p>Jika sudah. Tekan "simpan"</p>
        </div>
        <p v-if="!allDone" class="text-sm text-danger">*Harap isi semua untuk mengirim</p>
      </div>
      <van-button
        :disabled="!allDone"
        :loading="isLoading"
        type="info"
        loading-type="spinner"
        @click="submit"
        class="whitespace-nowrap bg-primary border-none"
      >
        <v-icon icon="material-symbols:send" class="text-2xl mr-1 inline" />
        <span class="ml-2 font-bold">Simpan</span>
      </van-button>
    </div>
  </div>
</template>
<script>
  // import PictureForm from "@/components/Forms/PictureForm.vue";
  import TextBoxForm from "@/components/Forms/TextBoxForm.vue";
  import MultiPictureForm from "@/components/Forms/MultiPictureForm.vue";
  // import instance from "@/plugins/axios";
  import { location } from "@/states/location";
  import local from "@/states/local";
  import { users } from "@/states/user";
  import { deleteUpload } from "@/plugins/axios";

  export default {
    name: "DailyReportNewPage",
    components: {
      MultiPictureForm,
      TextBoxForm
    },
    data() {
      return {
        check: null,
        isLoading: false,
        tracking: location,
        foto: [],
        users,
        keterangan: null,
        local
      };
    },
    async mounted() {},
    computed: {
      allDone() {
        return this.foto.isPassLimit && this.keterangan;
      }
    },
    methods: {
      async submit() {
        const toasty = this.$toast.loading({ message: "Mengupload foto...", forbidClick: true, duration: 0 });
        this.isLoading = true;

        const processedFoto = [];
        for (const x of this.foto.pictures) {
          const result = await local.processFile(x.picture).catch((err) => {
            console.error(err);
            toasty.clear();
            this.$toast.fail({ message: "Gagal mengupload foto", duration: 5000 });
            this.isLoading = false;
            return null;
          });
          processedFoto.push(result);
        }

        if (processedFoto.some((x) => !x)) {
          deleteUpload(processedFoto)
            .then(() => {
              toasty.clear();
              this.$toast.fail({ message: "Gagal mengupload foto. Coba lagi nanti...", duration: 5000 });
            })
            .catch(() => {});
          toasty.clear();
          this.isLoading = false;
          return;
        }

        console.log(processedFoto);

        toasty.message = "Mengirim data...";

        const coordCurrently = this.tracking;

        local
          .processData("/report/daily/assign", {
            currentLocation: [coordCurrently.latitude, coordCurrently.longitude],
            images: processedFoto,
            imageDescriptions: this.foto.pictures.map((x) => x.description),
            description: this.keterangan,
            groupId: this.users.data.workSite
          })
          .then(() => {
            this.isLoading = false;
            toasty.message = "Selesai!";
            toasty.clear();
            this.$router.go(-1);
          })
          .catch((err) => {
            this.isLoading = false;
            toasty.message = "Gagal mengirim data. Menghapus foto...";
            deleteUpload(processedFoto)
              .then(() => {
                toasty.clear();
                this.$toast.fail({ message: "Gagal mengirim. Coba lagi nanti...", duration: 5000 });
              })
              .catch(() => {});

            console.error(err);
          });
      }
    }
  };
</script>
